<template>
    <HamletTable
        :columns="columns"
        :fetch="fetch"
        @created="onTableCreated"
        @onRowClick="edit"
    >
        <template #header-controls>
            <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mt-0 btn-icon"
                @click="add"
                v-if="$can('visit', 'administration-production-units-add')"
            >
                <feather-icon icon="PlusIcon" />
            </b-button>
        </template>

        <template #header-label>
            {{ $t('Page(ProductionUnits):Component(Text):page-label') }}
        </template>

        <template #cell-city="data">
            {{ data.item.location ? data.item.location.city : '-' }}
        </template>

        <template #cell-validFrom="data">
            {{ data.item.validFrom ? renderDate(data.item.validFrom) : '-' }}
        </template>

        <template #cell-validTo="data">
            {{ data.item.validTo ? renderDate(data.item.validTo) : '-' }}
        </template>
    </HamletTable>
</template>

<script>
import {
    BButton
} from 'bootstrap-vue'
import HamletTable from "@core/components/common/HamletTable";
import {SupplyChain} from "@core/api";
import {DateRenderer} from "@core/mixins";
import Ripple from 'vue-ripple-directive'
import {OrganizationType} from "@/libs/supply-chain";

export default {
    mixins: [DateRenderer],
    directives: {Ripple},
    components: {
        HamletTable,
        BButton,
    },
    props: {
        supplierId: {
            required: true,
        }
    },
    data() {
        return {
            columns: [
                {
                    key: 'title',
                    label: this.$t('Component(Grid):column-name')
                },
                {
                    key: 'state',
                    label: this.$t('Component(Grid):column-state')
                },
                {
                    key: 'city',
                    label: this.$t('Component(Label):city')
                },
                {
                    key: 'validFrom',
                    label: this.$t('Component(Grid):column-valid-from')
                },
                {
                    key: 'validTo',
                    label: this.$t('Component(Grid):column-valid-to')
                },
            ],
            table: {
                config: {},
                cb: null
            },
            items: []
        }
    },
    methods: {
        onTableCreated(config, cb) {
            this.table.cb = cb;
            this.table.config = config;
        },
        fetch(config, cb) {
            const start = (config.page - 1) * config.perPage;
            cb(
                this.items.length,
                this.items.slice(start, start + config.perPage)
            );
        },
        edit(pu) {
            this.$router.push({
                name: 'administration-production-units-edit',
                params: {
                    type: OrganizationType.PRODUCTION_UNIT,
                    id: pu.id,
                    sid: this.supplierId
                }
            });
        },
        add() {
            this.$router.push({
                name: 'administration-production-units-add',
                params: {
                    type: OrganizationType.PRODUCTION_UNIT,
                    sid: this.supplierId
                }
            });
        }
    },
    created() {
        SupplyChain.getProductionUnits(this.supplierId).then(r => {
            this.items = r.data.items;
            this.fetch(this.table.config, this.table.cb);
        });
    }
}
</script>
